<template>
  <div class="q-product-slides">
    <template v-if="slides.length > 0">
      <!-- Main image -->
      <div class="q-slide-main">
        <splide :options="primaryOptions" ref="primary" :slides="slides">
          <splide-slide v-for="(slide, i) in slides" :key="i">
            <img :src="slide" alt="" class="q-slide-main__img" style="cursor: zoom-in" @click="openLightbox(i)" />
          </splide-slide>
        </splide>
      </div>

      <!-- Thumbnails — solo si hay más de 1 imagen -->
      <div v-if="slides.length > 1" class="q-slide-thumbs">
        <splide :options="secondaryOptions" :slides="slides" ref="secondary">
          <splide-slide v-for="(slide, i) in slides" :key="i">
            <img :src="slide" alt="" class="q-slide-thumb__img" />
          </splide-slide>
        </splide>
      </div>
    </template>

    <!-- Placeholder mientras carga -->
    <div v-else class="q-slide-placeholder">
      <div class="q-slide-placeholder__inner">
        <svg width="48" height="48" fill="none" viewBox="0 0 24 24">
          <rect width="24" height="24" rx="4" fill="var(--q-bg-elevated)"/>
          <path d="M4 16l4-4 3 3 4-5 5 6H4z" fill="var(--q-text-subtle)"/>
          <circle cx="8.5" cy="8.5" r="1.5" fill="var(--q-text-subtle)"/>
        </svg>
      </div>
    </div>

    <ImageLightbox :images="slides" :visible="lightbox.open" :start="lightbox.index" @close="lightbox.open = false" />
  </div>
</template>

<script>
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import ImageLightbox from "./ImageLightbox.vue";
import { mapMutations } from "vuex";

export default {
  name: "DetailsProductSlide",
  components: { Splide, SplideSlide, ImageLightbox },
  props: ["slides"],
  data() {
    return {
      synced: false,
      lightbox: { open: false, index: 0 },
      primaryOptions: {
        type: "fade", pagination: false, arrows: true, rewind: true,
      },
      secondaryOptions: {
        type: "slide",
        perPage: 4,
        rewind: true,
        gap: "8px",
        pagination: false,
        arrows: false,
        fixedWidth: 72,
        fixedHeight: 56,
        cover: true,
        focus: "center",
        isNavigation: true,
      },
    };
  },
  watch: {
    slides(val) {
      if (val.length > 1 && !this.synced) this.$nextTick(this.syncSplide);
    },
  },
  methods: {
    ...mapMutations({ setProduct: "ecommerce/SET_PRODUCT" }),
    openLightbox(i) { this.lightbox.index = i; this.lightbox.open = true; },
    syncSplide() {
      if (this.$refs.primary && this.$refs.secondary) {
        this.$refs.primary.sync(this.$refs.secondary.splide);
        this.synced = true;
      }
    },
  },
  beforeDestroy() { this.setProduct({}); },
};
</script>

<style scoped>
.q-product-slides { display: flex; flex-direction: column; gap: 8px; }

/* Main image */
.q-slide-main {
  border: 1px solid var(--q-border);
  border-radius: var(--q-radius);
  overflow: hidden;
  background: var(--q-bg-surface);
}
.q-slide-main__img {
  width: 100%;
  height: 340px;
  object-fit: contain;
  padding: 16px;
}

/* Thumbs */
.q-slide-thumbs { overflow: hidden; }
.q-slide-thumb__img {
  width: 100%; height: 100%;
  object-fit: contain;
  padding: 4px;
  background: var(--q-bg-surface);
}

/* Placeholder */
.q-slide-placeholder {
  border: 1px solid var(--q-border);
  border-radius: var(--q-radius);
  background: var(--q-bg-surface);
  height: 340px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.q-slide-placeholder__inner { opacity: 0.4; }

/* Splide overrides */
:deep(.splide__arrow) {
  background: var(--q-bg-elevated);
  border: 1px solid var(--q-border);
  opacity: 1;
}
:deep(.splide__arrow svg) { fill: var(--q-text-muted); }
:deep(.splide__arrow:hover) { background: var(--primary-color); }
:deep(.splide__arrow:hover svg) { fill: #ffffff; }
:deep(.splide__slide.is-active) {
  border: 2px solid var(--primary-color) !important;
  border-radius: 4px;
}
</style>
